import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getGalleryInner } from "../Service/Api";
import FilterContainer from "../utlis/FilterContainer";
import LazyLoad from "react-lazyload";
function GalleryInner() {
  const navigate = useNavigate();
  const [selectedYear, setSelectedYear] = useState("All");

  const [selectedMonth, setSelectedMonth] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleCount, setVisibleCount] = useState(8);

  const {
    data: galleryData = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["galleryInner"],
    queryFn: getGalleryInner,
  });

  const galleryDummyHome = [
    { title: "Gallery Title", img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg" },
    { title: "Gallery Title", img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg" },
    { title: "Gallery Title", img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg" },

  ];

  const galleryList =
    isError || !galleryData || galleryData.length === 0
      ? galleryDummyHome
      : galleryData;

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthOptions = ["All", ...monthNames];

  const yearRanges = [
    ...new Set(
      galleryList
        .map((item) => {
          const d = new Date(item.date);
          return !isNaN(d) ? d.getFullYear().toString() : null;
        })
        .filter(Boolean)
    ),
  ].sort((a, b) => b - a);

  const filterData = galleryList.filter((item) => {
    const date = new Date(item.date);
    const itemYear = date.getFullYear().toString();
    const itemMonth = monthNames[date.getMonth()];

    const matchYear = selectedYear === "All" || itemYear === selectedYear;
    const matchMonth = selectedMonth === "All" || itemMonth === selectedMonth;

    const matchSearch =
      item.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchYear && matchMonth && matchSearch;
  });

  const visibleItems = filterData.slice(0, visibleCount);

  const handleLoadMore = () => setVisibleCount((prev) => prev + 8);

  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <h1>Photo Gallery</h1>

        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Gallery</li>
        </ul>
      </div>
      {/* <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item active">Gallery</li>
        </ul>
      </div> */}

      <div className="innersec">
        <div className="container">
     
          <FilterContainer
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            yearRanges={yearRanges}
            monthOptions={monthOptions}
            totalCount={filterData.length}
          />

          <div className="row years year2024 showYear">
            {isLoading ? (
              <p className="text-center text-muted py-5">Loading gallery...</p>
            ) : visibleItems.length > 0 ? (
              visibleItems
                .filter((item) => item.category === "PhotoGallery")
                .map((item, index) => {
                  const date = new Date(item.date);
                  const day = date.getDate();
                  const month = monthNames[date.getMonth()];

                  return (
                    <div
                      className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 galleryCount"
                      key={index}>
                      <div className="gallery-inner">
                        <div className="gallery-blks">
                          <div className="backDiv"></div>
                          <LazyLoad
                            offset={10}
                            placeholder={
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg"
                                alt="Loading..."
                                className="img-fluid"
                              />
                            }>
                            <img
                              src={
                                item.attachments
                                  ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                                  : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Gallery.jpg"
                              }
                              className="img-fluid"
                              alt={item.title || "Gallery"}
                            />
                          </LazyLoad>
                        </div>
                        <div className="gallery-content">
                          <div className="gallery-date">
                            <h6>
                              {day} <span>{month}</span>
                            </h6>
                            <div className="gall-num">
                              <h5>
                                <span>Number Of Photos :</span>
                                {item.attachments.length || "N/A"}
                              </h5>
                            </div>
                          </div>
                          <div className="gallery-title">
                            <h3>{item.title}</h3>
                          </div>
                          <Link
                            to={`/sub-gallery/${item._id || ""}`}
                            className="viewmore">
                            View More <i className="bi bi-arrow-right"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  );
                })
            ) : (
              galleryDummyHome.map((data, index) => (
                <div
                  className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-12 galleryCount"
                  key={index}>
                  <div className="gallery-inner">
                    <div className="gallery-blks">
                      <div className="backDiv"></div>
                      <img src={data.img} className="img-fluid" alt="Frank Anthony Bangalore" />
                    </div>
                    <div className="gallery-content">
                      <div className="gallery-date">
                        <h6>
                          DD <span>MM</span>
                        </h6>
                        <div className="gall-num">
                          <h5>
                            <span>Number Of Photos :</span> NO
                          </h5>
                        </div>
                      </div>
                      <div className="gallery-title">
                        <h3>{data.title}</h3>
                      </div>
                      <Link to="/sub-gallery" className="viewmore">
                        View More <i className="bi bi-arrow-right"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {filterData.length > visibleCount && (
            <div className="row">
              <div className="col-12 text-center mt-4">
                <button
                  className="btn load_more_btn px-4 py-2"
                  onClick={handleLoadMore}>
                  Load More
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default GalleryInner;
